export const EVENT = {
  SUBMIT_CHARGE: 'onSubmitCharge',
  CHANGE_ALIGN_STATE: ' onChangeAlignState',
  SUBMIT_RESULT: 'onSubmitResult',
  CLICK_RESTART_BUTTON: 'onClickRestartButton ',
  CLICK_MODAL: 'onClickModal',
  INPUT_OVER_MAX_LENGTH: 'onInputOverMaxLength',
};
